import lodash from 'lodash';

const getters = {
  dialog(state) {
    return state.dialog;
  },
  dialogParams(state) {
    return state.dialogParams;
  },
  questions(state) {
    return state.questions;
  },
  loadingQuestions(state) {
    return state.loadingQuestions;
  },
  appointments(state) {
    return state.appointments;
  },
  loadingAppointments(state) {
    return state.loadingAppointments;
  },
  partnerData(state) {
    return state.partnerData;
  },
  loadingPartnerData(state) {
    return state.loadingPartnerData;
  },
  authorizationDialogShown(state) {
    return state.authorizationDialogShown;
  },
  userDeactivated(state) {
    return state.userDeactivated;
  },
  passwordValidation(state) {
    return state.passwordValidation;
  },
  paymentMethodName(state) {
    return state.paymentMethodName;
  },
  dashboardGtmSent(state) {
    return state.dashboardGtmSent;
  }
};

const mutations = {
  setDialog(state, payload) {
    if (payload && typeof payload === 'object') {
      state.dialogParams = payload.params;
      state.dialog = payload.name;
    } else {
      if (payload !== false) {
        // case for close dialog (payload === false) is solved in mixin profileDialogs.js in watch dialog
        if (payload !== state.dialog) {
          state.dialogParams = {};
        }
      }
      state.dialog = payload;
    }
  },
  setQuestions(state, payload) {
    state.questions = payload;
  },
  setLoadingQuestions(state, payload) {
    state.loadingQuestions = payload;
  },
  setAppointments(state, payload) {
    state.appointments = payload;
  },
  setLoadingAppointments(state, payload) {
    state.loadingAppointments = payload;
  },
  setPartnerData(state, payload) {
    state.partnerData = payload;
  },
  setLoadingPartnerData(state, payload) {
    state.loadingPartnerData = payload;
  },
  setAuthorizationDialogShown(state, payload) {
    state.authorizationDialogShown = payload;
  },
  setUserDeactivated(state, payload) {
    state.userDeactivated = payload;
  },
  setPasswordValidation(state, payload) {
    state.passwordValidation = payload;
  },
  setPaymentMethodName(state, payload) {
    state.paymentMethodName = payload;
  },
  deleteDialogParams(state) {
    state.dialogParams = {};
  },
  setDashboardGtmSent(state, payload) {
    state.dashboardGtmSent = payload;
  }
};

const actions = {
  async setPasswordValidation({ commit, state }, payload) {
    if (lodash.isEmpty(state.passwordValidation)) {
      let url = '/v3/password-requirements';
      if (payload?.prop && payload?.val) {
        url += `?${payload.prop}=${encodeURIComponent(payload.val)}`;
      }
      await this.$http
        .get(url)
        .then(data => {
          commit('setPasswordValidation', data);
        })
        .catch(() => {
          return {};
        });
    }
  },
  async setQuestions({ commit, dispatch }) {
    commit('setLoadingQuestions', true);
    return await this.$http
      .get('/v3/fe/questions')
      .then(data => {
        commit('setQuestions', data);
        return data;
      })
      .catch(err => {
        dispatch('errorModal/handleError', { error: err, code: '0x00000059' }, { root: true });
        return {};
      })
      .finally(() => {
        commit('setLoadingQuestions', false);
      });
  },
  async setAppointments({ commit, dispatch }) {
    commit('setLoadingAppointments', true);
    return await this.$http
      .get('/v3/fe/appointments')
      .then(data => {
        commit('setAppointments', data);
        return data;
      })
      .catch(err => {
        dispatch('errorModal/handleError', { error: err, code: '0x0000005A' }, { root: true });
        return {};
      })
      .finally(() => {
        commit('setLoadingAppointments', false);
      });
  },
  async updatePartner({ commit, state, dispatch }, payload) {
    if (
      !lodash.isEmpty(state.partnerData) &&
      state.partnerData.url === payload.partnerUrl &&
      state.partnerData.region.toLowerCase() === payload.region.toLowerCase()
    ) {
      return;
    }

    commit('setLoadingPartnerData', true);

    const url = '/v3/fe/partners/' + payload.partnerUrl + '/' + payload.region;

    return await this.$http
      .get(url)
      .then(data => {
        commit('setPartnerData', data);
      })
      .catch(error => {
        dispatch('errorModal/handleError', { error, code: '0x0000005B' }, { root: true });
      })
      .finally(() => {
        commit('setLoadingPartnerData', false);
      });
  },

  setAuthorizationDialogShown({ commit }, payload) {
    commit('setAuthorizationDialogShown', payload);
  },
  resetProfileStore({ commit, dispatch }) {
    dispatch('setAuthorizationDialogShown', false);
    commit('dynamicForms/resetStore', null, { root: true });
    commit('profile/login/resetStore', null, { root: true });
    commit('dynamicForms/updateInitialLoading', false, { root: true });
    commit('profile/prevention/resetStore', null, { root: true });
    commit('profile/explore/resetStore', null, { root: true });
    commit('setPasswordValidation', {});
    commit('setLoadingPartnerData', true);
    commit('setPartnerData', {});
    commit('setDialog', false);
    commit('setDashboardGtmSent', false);
  },
  setDialog({ commit }, payload) {
    commit('setDialog', payload);
  },
  deleteDialogParams({ commit }) {
    commit('deleteDialogParams');
  },
  setUserDeactivated({ commit }, payload) {
    commit('setUserDeactivated', payload);
  }
};

export const dashboard = {
  state: () => ({
    dialog: false,
    dialogParams: {},
    questions: [],
    loadingQuestions: true,
    appointments: [],
    loadingAppointments: true,
    partnerData: {},
    loadingPartnerData: true,
    authorizationDialogShown: false,
    userDeactivated: false,
    passwordValidation: {},
    paymentMethodName: '',
    dashboardGtmSent: false
  }),
  getters,
  mutations,
  actions,
  namespaced: true
};
